import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Button from '@components/shared/Button'
import Tooltip from '@components/shared/Tooltip'
import MustBePremiumDialog from '@components/shared/dialogs/MustBePremiumDialog'
import MustLoginDialog from '@components/shared/dialogs/MustLoginDialog'
import PurchaseLearnDialog from '@components/shared/dialogs/PurchaseLearnDialog'
import AddToCollectionDialog from '@components/shared/dialogs/collection/AddToCollectionDialog'
import { useTitle } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import AddToMenu from './AddToMenu'

import 'tippy.js/dist/tippy.css'

const AddToButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { pathname } = useLocation()
  const session = useSession()
  const { title } = useTitle()

  const [showMenu, setShowMenu] = useState(false)

  const onClick = () => {
    if (isLearnPcPreview(pathname)) {
      openDialog('purchase_learn')
    } else if (!session.isLoggedIn()) {
      openDialog('must_login_collections')
    } else {
      setShowMenu(true)
    }
  }

  const signupType = isLearnPcPreview(pathname) ? 'teacher' : undefined

  return (
    <>
      <Tooltip
        arrow
        onClickOutside={() => setShowMenu(false)}
        content={<AddToMenu onClick={() => setShowMenu(false)} />}
        onHide={() => setShowMenu(false)}
        interactive
        placement="bottom"
        visible={showMenu}>
        <Button variant="outline" className="text-md w-full py-1.5" onClick={onClick}>
          {t('action.addTo')}
        </Button>
      </Tooltip>
      <MustLoginDialog
        title={t('action.addToCollection')}
        action={t('action.addToCollection')}
        signUpType={signupType}
        name="must_login_collections"
      />
      <MustBePremiumDialog
        title={t('action.addToCollection')}
        action={t('action.addToCollection')}
        name="require_premium_collections"
      />
      <PurchaseLearnDialog />
      <AddToCollectionDialog data={{ type: 'title', uuid: title.uuid }} />
    </>
  )
}

export default AddToButton
